import { useState, useEffect } from "react";
import MasterGamesList from "../data/MasterGamesList";
import { useGlobalContext } from "../data/GlobalContext";
import GameHistory from "./request_history/GameHistory";

export default function Activity({ onClose }) {
	const { vipDetails } = useGlobalContext();

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<div className="openProfileItems-container">
			{windowWidth <= 840 && (
				<div className="close-profile-module-container">
					<div className="profile-logo">
						<a href="/">
							<img src="/images/icon/fgh-logo.webp" alt="FGH Logo" />
						</a>
					</div>
					<button className="close-profile-module-btn" onClick={onClose}>
						<img src="/images/icon/ARROW.webp" alt="" /> Back
					</button>
				</div>
			)}
			<div className="openActivity">
				<div className="activity-recent-games activity-page-style">
					<MasterGamesList recentgames="all" headerTag="h3" limit={5} />
				</div>
				<div className="activity-game-transaction">
					<div>
						<label>Deposit This Month</label>{" "}
						<span>{vipDetails.vipTotalDeposit}</span>
					</div>
					<div>
						<label>Turnover This Month</label>
						<span>{vipDetails.vipTotalTurnover}</span>
					</div>
				</div>
				<div className="activity-game-report activity-page-style">
					<GameHistory />
				</div>
			</div>
		</div>
	);
}
